import { createAction } from "@reduxjs/toolkit";
import {
  AddMessagesLoaderActionType,
  AddRoomMediaActionType,
  AddRoomMessagesActionType,
  ClearRoomMessagesActionType,
  ClearRoomSelectedMessagesActionType,
  EditMessagesLoaderActionType,
  EditRoomMessageActionType,
  MarkAsReadMessagesType,
  RemoveFakeMessage,
  RemoveMessagesLoaderActionType,
  RemoveMessagesLoadersActionType,
  RemoveRoomMediaActionType,
  RemoveRoomMessageActionType,
  RemoveRoomMessagesActionType,
  ResetSharedMediaActionType,
  SetScrolledMessageActionType,
  SetSharedMediaActionType,
  UpdateRoomSelectedMessagesActionType,
  ADD_ROOM_MESSAGES,
  EDIT_ROOM_MESSAGE,
  MARK_AS_READ_MESSAGES,
  REMOVE_ROOM_MESSAGE,
  REMOVE_ROOM_MESSAGES,
  CLEAR_ROOM_MESSAGES,
  UPDATE_SELECTED_MESSAGES,
  CLEAR_SELECTED_MESSAGES,
  ADD_ROOM_MEDIA,
  REMOVE_ROOM_MEDIA,
  ADD_MESSAGES_LOADER,
  EDIT_MESSAGES_LOADERS,
  REMOVE_MESSAGES_LOADER,
  REMOVE_MESSAGES_LOADERS,
  SET_SCROLLED_MESSAGE,
  SET_SHARED_MEDIA,
  RESET_SHARED_MEDIA,
  REMOVE_FAKE_MESSAGE,
  GO_TO_MESSAGE,
  GoToMessageType,
} from "./types";

export const addRoomMessages = createAction<AddRoomMessagesActionType["payload"]>(ADD_ROOM_MESSAGES);
export const editRoomMessage = createAction<EditRoomMessageActionType["payload"]>(EDIT_ROOM_MESSAGE);
export const markAsReadMessages = createAction<MarkAsReadMessagesType["payload"]>(MARK_AS_READ_MESSAGES);
export const removeRoomMessage = createAction<RemoveRoomMessageActionType["payload"]>(REMOVE_ROOM_MESSAGE);
export const removeRoomMessages = createAction<RemoveRoomMessagesActionType["payload"]>(REMOVE_ROOM_MESSAGES);
export const clearRoomMessages = createAction<ClearRoomMessagesActionType["payload"]>(CLEAR_ROOM_MESSAGES);
export const updateRoomSelectedMessages = createAction<UpdateRoomSelectedMessagesActionType["payload"]>(UPDATE_SELECTED_MESSAGES);
export const clearRoomSelectedMessages = createAction<ClearRoomSelectedMessagesActionType | undefined>(CLEAR_SELECTED_MESSAGES);
export const addRoomMedia = createAction<AddRoomMediaActionType["payload"]>(ADD_ROOM_MEDIA);
export const removeRoomMedia = createAction<RemoveRoomMediaActionType["payload"]>(REMOVE_ROOM_MEDIA);
export const addMessagesLoader = createAction<AddMessagesLoaderActionType["payload"]>(ADD_MESSAGES_LOADER);
export const editMessagesLoader = createAction<EditMessagesLoaderActionType["payload"]>(EDIT_MESSAGES_LOADERS);
export const removeMessagesLoader = createAction<RemoveMessagesLoaderActionType["payload"]>(REMOVE_MESSAGES_LOADER);
export const removeMessagesLoaders = createAction<RemoveMessagesLoadersActionType["payload"]>(REMOVE_MESSAGES_LOADERS);
export const setScrolledMessage = createAction<SetScrolledMessageActionType["payload"]>(SET_SCROLLED_MESSAGE);
export const setSharedMedia = createAction<SetSharedMediaActionType["payload"]>(SET_SHARED_MEDIA);
export const resetSharedMedia = createAction<ResetSharedMediaActionType["payload"]>(RESET_SHARED_MEDIA);
export const removeFakeMessage = createAction<RemoveFakeMessage["payload"]>(REMOVE_FAKE_MESSAGE);
export const goToMessage = createAction<GoToMessageType["payload"]>(GO_TO_MESSAGE);
